import { render, staticRenderFns } from "./performance-bar.vue?vue&type=template&id=673ba014"
import script from "./performance-bar.ts?vue&type=script&lang=ts&external"
export * from "./performance-bar.ts?vue&type=script&lang=ts&external"
import style0 from "./performance-bar.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports